import { commonWebSocket } from '@services/common/common.constants';
import { IRatingDetails } from '@app-types/websocket/rating.types';
import { createReducer } from 'redux-act';
import { dismissRatingPrompt, displayRatingPrompt } from './rating.actions';
import { ratingTimingAllowsPrompt } from './rating.utils';

const defaultState = {
  ratingDetails: undefined as IRatingDetails | undefined,
  showRatingPrompt: false,
};

const reducer = createReducer<typeof defaultState>({}, defaultState);

reducer
  .on(commonWebSocket.snapshot.RATINGS_SNAPSHOT, (state:any, payload:any) => {
    if (payload && payload.ratingDetails && typeof payload.ratingDetails === "object") {
      return {
        ...state,
        ratingDetails: payload.ratingDetails,
        showRatingPrompt: state.showRatingPrompt && ratingTimingAllowsPrompt(payload.ratingDetails),
      };
    }
    return state;
  })
  .on(displayRatingPrompt, (state:any) => {
    return {
      ...state,
      showRatingPrompt: true,
    };
  })
  .on(dismissRatingPrompt, (state:any) => {
    return {
      ...state,
      showRatingPrompt: false,
    };
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/services/rating/rating.reducer.ts